import { calcCellSize } from '../components/Game/src/geometry';
export function sliceByPos(slices, pos) {
    var cellSize = calcCellSize();
    for (var i = 0; i < slices.length; i++) {
        var slice = slices[i];
        var minX = slice.pos.x;
        var minY = slice.pos.y;
        var maxX = minX + slice.gridSize * cellSize;
        var maxY = minY + (slice.data.length / slice.gridSize) * cellSize;
        if (pos.x >= minX && pos.x <= maxX && pos.y >= minY && pos.y <= maxY) {
            return slice;
        }
    }
    return null;
}
